import type { ReactNode } from 'react';
import { useIdentidade } from '../hooks/useSessao';

/**
 * A mesma rota, duas telas: a da operação (admin) e a das partes.
 *
 * A tela do admin opera — fecha, protocola, cobra — e mostra tudo; a das
 * partes mostra o que é da empresa escolhida, na visão do papel dela. Separar
 * as duas, em vez de esconder botão por botão, é o que impede um controle de
 * operação esquecido de aparecer para um cliente. A API recusa do mesmo jeito.
 */
export function AdminOuParte(props: {
  readonly admin: ReactNode;
  readonly parte: ReactNode;
}): JSX.Element {
  const identidade = useIdentidade();
  return <>{identidade?.isAdmin === true ? props.admin : props.parte}</>;
}
